import { SellerType } from "./types";

/** Predefined Amazon USA product categories (sample – can be extended from Amazon catalog) */
export const AMAZON_USA_CATEGORIES = [
  "All",
  "Amazon Devices & Accessories",
  "Amazon Kindle",
  "Appliances",
  "Arts, Crafts & Sewing",
  "Automotive",
  "Baby",
  "Beauty & Personal Care",
  "Books",
  "Camera & Photo",
  "Cell Phones & Accessories",
  "Clothing, Shoes & Jewelry",
  "Collectible Coins",
  "Computers & Accessories",
  "Electronics",
  "Garden & Outdoor",
  "Grocery & Gourmet Food",
  "Health & Household",
  "Home & Kitchen",
  "Industrial & Scientific",
  "Kindle Store",
  "Kitchen & Dining",
  "Musical Instruments",
  "Office Products",
  "Patio, Lawn & Garden",
  "Pet Supplies",
  "Software",
  "Sports & Outdoors",
  "Tools & Home Improvement",
  "Toys & Games",
  "Video Games",
] as const;

export const SELLER_TYPES: SellerType[] = ["Amazon", "FBA", "FBM"];

export const MARKETPLACE_OPTIONS = [{ value: "USA" as const, label: "USA" }];
